
<div class="container-fluid mt-3">
    <div class="row">
        <div class="col common-list-wrapper">           
            <ul class="nav nav-pills flex-column">
                <li class="nav-item" *ngFor="let repository of repositories; let i = index;">
                    <a routerLinkActive="active" class="nav-link" aria-current="page" routerLink="{{repository}}">
                        <i class="fa-solid fa-folder text-dark me-1"></i>
                        <span>{{repository}}</span>
                    </a>
                </li>                
            </ul>                  
        </div>        
        <div class="col">               
            <router-outlet></router-outlet>
        </div>
    </div>
</div>





